module.exports = __webpack_public_path__ + "img/Docx.b4c60231.png";